/**
 * Like lodash `mapValues`: returns a new object with the same keys and each
 * value replaced by `fn(value, key)`. Only own enumerable string keys are visited.
 */
export const mapValues = <T extends object, R>(
  obj: T,
  fn: (value: T[keyof T], key: keyof T & string) => R,
): { [K in keyof T]: R } =>
  Object.fromEntries(
    Object.entries(obj).map(([key, value]) => [key, fn(value as T[keyof T], key as keyof T & string)]),
  ) as { [K in keyof T]: R };
